import type { SVGProps } from 'react';

const SvgStarFill = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M16.94 20.22c-.16 0-.32-.04-.47-.11l-4.48-2.35-4.48 2.35c-.34.18-.74.15-1.05-.08-.31-.22-.46-.6-.4-.98l.86-4.99-3.62-3.53a1.006 1.006 0 0 1 .56-1.71l5.01-.73 2.24-4.54c.34-.68 1.46-.68 1.79 0l2.24 4.54 5.01.73c.38.05.69.32.81.68s.02.76-.25 1.03l-3.62 3.53.86 4.99c.06.38-.09.75-.4.98-.17.13-.38.19-.59.19z"
    />
  </svg>
);
export default SvgStarFill;
